import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const AvocadoBurgerButton = styled.button`
  padding: 15px 0 15px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 46px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  position: relative;

  &:focus {
    outline: none;
  }

  div {
    &,
    :before,
    :after {
      display: block;
      content: "";
      width: 16px;
      height: 2px;
      background: ${props =>
        props.inverse ? `white` : props.theme.colors.black};
      transition: all 150ms linear;
    }
    :before,
    :after {
      position: absolute;
    }

    transform: ${({ isOpen }) =>
      !isOpen
        ? "translate3d(0,-5px,0) rotate(0)"
        : "translate3d(0,0,0) rotate(45deg)"};
    transform-origin: 50%;

    :before {
      opacity: ${({ isOpen }) => (!isOpen ? "1" : "0")};
      transform: ${({ isOpen }) =>
        !isOpen
          ? "translate3d(0,5px,0) rotate(0deg)"
          : "translate3d(0,0,0) rotate(-90deg)"};
    }

    :after {
      transform: ${({ isOpen }) =>
        !isOpen
          ? "translate3d(0,10px,0) rotate(0deg)"
          : "translate3d(0,0,0) rotate(-90deg)"};
    }
  }
`
export const AvocadoBurger = props => (
  <AvocadoBurgerButton {...props}>
    <div />
  </AvocadoBurgerButton>
)

AvocadoBurger.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  inverse: PropTypes.bool,
}
